import React from 'react';
import tpl from '../templates/pbpEntityNew';
import BaseNewCardView from '../../Cards/views/BaseNewCardView';
import {apiback} from '../../../config';
import PbpEntityModel from '../Models/pbp-entity.m';

export default class extends BaseNewCardView {
    template = tpl;

    constructor(props, context) {
        super(props, context);

        const ssrData = context && context.ssrData;

        this.state = {
            ...this.state,
            partnerTab: 'partner-21',
            partnersData: ssrData ? ssrData.partnersData || [] : null,
            where_by_2: ['path'],
            search_by_2: ['/credit/pbp'],
            widgets_2: (ssrData && ssrData.widgets_2) || []
        };

        this.sliderRefPartners = React.createRef();
    }

    togglePartnerTab = tab => {
        this.setState({partnerTab: tab});
    };

    componentDidMount() {
        super.componentDidMount();
        const widgets2Promise = this.widgetsHelper.getWidgets_2.call(this);
        fetch(apiback('PAY_BY_PARTS_PARTNERS'))
            .then(res => res.json())
            .then(response => {
                const partnersOnly = Object.values(response).filter(
                    item => typeof item === 'object' && item.id
                );
                this.setState({partnersData: partnersOnly});
            });

        const calcPromise = fetch(apiback('BUSINESS_PBP_ENTITY_CALC'))
            .then(response => response.json())
            .then(json =>
                this.setState({
                    model: new PbpEntityModel(json.data)
                })
            );

        Promise.all([widgets2Promise, calcPromise]).then(() => {
            this.handleScrollFromQuery();
        });

        this.openModalScreen();
    }

    openModalScreen() {
        const params = new URLSearchParams(window.location.search);
        if (params.has('proposal')) {
            this.setState({showModal: true});
        }
    }

    scrollConfig() {
        return [{param: 'calc', selector: '.calculator-new'}];
    }

    static displayName = 'Business.Views.PbpEntity';
}
